import ajax from "../utils/request";
const playlistApi = {
  /********************************合集列表*********************************** */
  // 获取合集列表
  getPlaylistList(params) {
    return ajax({
      url: "/collection/list",
      type: "get",
      params: params,
    });
  },
  // 添加合集
  addPlaylist(params) {
    return ajax({
      url: "/collection/create",
      type: "post",
      params: params,
    });
  },
  // 删除合集
  delPlaylist(params) {
    return ajax({
      url: "/collection/delete",
      type: "post",
      params: params,
    });
  },
  // 修改合集
  updatePlaylist(params) {
    return ajax({
      url: "/collection/update",
      type: "post",
      params: params,
    });
  },
  // 批量修改
  batchEditSta(params) {
    return ajax({
      url: "/collection/batch/status",
      type: "post",
      params: params,
    });
  },
  // 批量设置专题
  batchAddSection(params) {
    return ajax({
      url: "/collection/batch/addToSec",
      type: "post",
      params: params,
    });
  },
  /********************************合集专题配置列表*********************************** */
  // 获取合集专题配置列表
  getPlaylistSectionList(params) {
    return ajax({
      url: "/collection_section/list",
      type: "get",
      params: params,
    });
  },
  // 添加合集专题配置
  addPlaylistSection(params) {
    return ajax({
      url: "/collection_section/create",
      type: "post",
      params: params,
    });
  },
  // 删除合集专题配置
  delPlaylistSection(params) {
    return ajax({
      url: "/collection_section/delete",
      type: "post",
      params: params,
    });
  },
  // 删除专题下的合集
  delSectionPlaylist(params) {
    return ajax({
      url: "/collection_section/delete_collection",
      type: "post",
      params: params,
    });
  },
  // 修改合集专题配置
  updatePlaylistSection(params) {
    return ajax({
      url: "/collection_section/update",
      type: "post",
      params: params,
    });
  },
  // 添加合集到专题
  addPlaylistToSection(params) {
    return ajax({
      url: "/collection_section/update_collection",
      type: "post",
      params: params,
    });
  },
  /********************************合集帖子列表*********************************** */
  // 获取合集帖子列表
  getPlaylistVideoList(params) {
    return ajax({
      url: "/collection_video/list",
      type: "get",
      params: params,
    });
  },
  // 添加合集帖子
  addPlaylistVideo(params) {
    return ajax({
      url: "/collection_video/create",
      type: "post",
      params: params,
    });
  },
  // 删除合集帖子
  delPlaylistVideo(params) {
    return ajax({
      url: "/collection_video/delete",
      type: "post",
      params: params,
    });
  },
  // 修改合集帖子
  updatePlaylistVideo(params) {
    return ajax({
      url: "/collection_video/update",
      type: "post",
      params: params,
    });
  },
  /********************************合集模块配置列表*********************************** */
  // 获取合集模块配置列表
  getCollectioConfigList(params) {
    return ajax({
      url: "/collection_config/list",
      type: "get",
      params: params,
    });
  },
  // 添加合集模块配置
  addCollectioConfig(params) {
    return ajax({
      url: "/collection_config/create",
      type: "post",
      params: params,
    });
  },
  // 删除合集模块配置
  delCollectioConfig(params) {
    return ajax({
      url: "/collection_config/delete",
      type: "post",
      params: params,
    });
  },
  // 修改合集模块配置
  updateCollectioConfig(params) {
    return ajax({
      url: "/collection_config/update",
      type: "post",
      params: params,
    });
  },
};
export default playlistApi;
